import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import { applyTheme } from './theme';
import { syncPlatformAttr } from './platform';

applyTheme();
// Платформа в data-атрибут до первого рендера: иначе шапка успевает мигнуть
// веб-видом внутри Telegram.
syncPlatformAttr();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



